import { Grid, Typography } from "@mui/material"
import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"
import React from "react"
import hero2 from "../../../assets/new_images/hero_2.png"
import "./About.css"

const AboutHeroHeader = ({ top }) => {
  let { ref, inView, entry } = useInView()
  return (
    <div
      className="about_hero_header"
      ref={ref}
      style={top ? { paddingTop: top } : {}}
    >
      <Grid
        container
        spacing={3}
        className="Grid_container_spread_tablet custom_main_container"
      >
        <Grid item xs={12} md={6}>
          <motion.div
            className="about_hero_content"
            initial={inView === false ? { y: 30, opacity: 0 } : {}}
            animate={inView === true ? { y: 0, opacity: 1 } : {}}
            transition={{ bounce: false, type: "spring", stiffness: 30 }}
          >
            <Typography variant="h2" className="heading_1">
              Supplying consumers with financial tools
            </Typography>
            <Typography variant="h2" className="heading_2">
              {"&"} helping merchants drive growth.
            </Typography>
          </motion.div>
        </Grid>
        <Grid item xs={12} md={6}>
          <motion.div
            className="about_hero_header_img"
            initial={inView === false ? { y: 30, opacity: 0 } : {}}
            animate={inView === true ? { y: 0, opacity: 1 } : {}}
            transition={{ bounce: false, type: "spring", stiffness: 30 }}
          >
            <img src={hero2} alt="hero" />
          </motion.div>
        </Grid>
      </Grid>
    </div>
  )
}

export default AboutHeroHeader
